import { render, staticRenderFns } from "./TabelaValoresMA.vue?vue&type=template&id=6cadccd0"
import script from "./TabelaValoresMA.vue?vue&type=script&lang=js"
export * from "./TabelaValoresMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports